/**

 */
import { useState } from 'react';
import './styles.scss';

interface IErrorModalProps {
    children: string;
    header: string;
}
const ErrorModal = (props: IErrorModalProps) => {

  const [isHidden, setHidden] = useState<boolean>(false);

  return (
    <div className={isHidden? 'error__component--hidden' : 'error__component'}>
      <div className="error__modal__backdrop" />
      <div className="error__modal">
        <div className="error__modal__exitButton" onClick={() => setHidden(true)} />
        <div className="error__modal__card">
          <div className="error__modal__card__title">
            {props.header}
          </div>
          <div className="error__modal__card__description">
            {props.children}
          </div>
          <div className="error__modal__card__button" onClick={() => window.location.reload()}>
           Refresh
          </div>
        </div>
      </div>
    </div>
  );
};



export default ErrorModal;
